import React from 'react';
import Lightbox from 'react-image-lightbox';
import { IPicture } from '../../../../../interfaces/professional/Professional';

interface Props {
  isOpen: boolean;
  pictures: Array<IPicture>;
  onClose: () => void;
  photoIndex: number;
  onMove: (index: number) => void;
}

const LightBoxWrapper = ({ isOpen, pictures, onClose, photoIndex, onMove }: Props) => {
  if (isOpen) {
    return (
      <Lightbox
        mainSrc={pictures[photoIndex].url}
        onCloseRequest={onClose}
        nextSrc={pictures[(photoIndex + 1) % pictures.length].url}
        prevSrc={pictures[(photoIndex + pictures.length - 1) % pictures.length].url}
        onMovePrevRequest={() => onMove((photoIndex + pictures.length - 1) % pictures.length)}
        onMoveNextRequest={() => onMove((photoIndex + 1) % pictures.length)}
        enableZoom={false}
        animationDisabled={false}
        animationOnKeyInput={true}
        imageTitle={pictures[photoIndex].description}
      />
    );
  }
  return null;
};

export default LightBoxWrapper;
